import type { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import * as Sentry from '@sentry/browser';

import { useClient, useStateMachine } from '@/hooks';
import useLazyTrack from '@/hooks/tracking/useLazyTrack';
import { ActorTypeEnum, SourceEnum, VerbEnum } from '@/tracker/enums';
import StatesEnum from '@/utils/enums/StatesEnum';
import { useMscPipeline } from '@/services/pre-enrollment';
import CarouselInstructions from '../carousel-instructions';

function Instruction(): ReactElement {
  const history = useHistory();
  const {
    setActualState,
    currentState,
    mscPipelineId,
    selectionProcessId,
    clientId,
    processInfo,
  } = useClient();
  const track = useLazyTrack();
  const { changeMscPipeline } = useMscPipeline();
  const { getStateObject } = useStateMachine();

  const changePipelineState = () => {
    changeMscPipeline({
      mscPipelineId,
      selectionProcessId,
      event: StatesEnum.WELCOME_PAGE_FINISHED,
    })
      .then(async (res) => {
        const { data } = await res;
        await setActualState(data?.actual_state);

        track(
          'Financing Request Started',
          {
            actor: {
              user_id: clientId,
              type: ActorTypeEnum.CANDIDATE,
              role: '',
            },
            object: {
              path: window.location.pathname,
              url: window.location.href,
              component: 'Começar',
              process_info: processInfo,
            },
            context: {
              source: SourceEnum.FINANCING_REQUEST,
            },
            verb: VerbEnum.CLICK,
          },
          'track',
        );

        const stateObj = getStateObject({ state: data?.actual_state });
        if (stateObj) {
          history?.push(stateObj.allowedUrls[0]);
        }
      })
      .catch((err) => {
        const payload = {
          mscPipelineId,
          selectionProcessId,
          currentState,
        };
        Sentry.setUser({ id: clientId });
        Sentry.captureException({ err, payload });
      });
  };

  return <CarouselInstructions handleClick={() => changePipelineState()} />;
}

export default Instruction;
